import BasicLayout from '@/layout/BasicLayout.vue'

const qcRouter = {
  path: '/qc',
  component: BasicLayout,
  children: [
    {
      path: '/qc/qccontrol',
      component: () => import('../../views/qc/index.vue'),
      children: [
        {
          path: '/qc/qccontrol/cause-error',
          component: () => import('../../views/qc/cause-error/index.vue'),
        },
        {
          path: '/qc/qccontrol/quality-control',
          component: () => import('../../views/qc/quality-control/index.vue'),
        }
      ],
    },
    {
      path: '/qc/qccontrol/cause-error',
      component: () => import('../../views/qc/cause-error/index.vue'),
    },
    {
      path: '/qc/qccontrol/quality-control',
      component: () => import('../../views/qc/quality-control/index.vue'),
    }
  ],
}

export default qcRouter
